<template>
  <section class="row">
    <div class="col-12">
      <div class="col-md-9 mx-auto">
        <v-place
          input-id="local-address"
          label="Adresse du local"
          module-name="contract"
          getter-name="get"
          setter-name="updateSubscription"
          :getter-function="({ risk: {local: { address }} }) => address"
          path="risk.local.address"
          error-message="Adresse incomplète"
          class="my-3"
        />
        <v-select
          input-id="local-occupant"
          label="Situation"
          :list="occupantList"
          path="risk.local.occupant"
          module-name="contract"
          getter-name="get"
          setter-name="updateSubscription"
          :getter-function="({ risk: { local: { occupant } } }) => occupant"
          class="my-3"
        />
        <v-input
          input-id="area-local"
          label="Superficie (m²)"
          mask="number"
          placeholder="42"
          module-name="contract"
          getter-name="get"
          setter-name="updateSubscription"
          :getter-function="({ risk: { local: { area } } }) => area"
          :input-validation="validateArea"
          path="risk.local.area"
          error-message="La surface doit être inférieure à 1 000 m²"
          class="my-3"
          @validation="(value) => setValidation('area', value)"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import Place from '@/components/common/input/Place2.vue';
import Input from '@/components/common/input/Input2.vue';
import Select from '@/components/common/input/CustomSelect2.vue';

export default {
  name: 'SurveyLocal',
  components: {
    'v-place': Place,
    'v-input': Input,
    'v-select': Select,
  },
  data() {
    return {
      addressValid: false,
      areaValid: false,
    };
  },
  computed: {
    ...mapGetters({
      occupantList: 'rater/qualityOccupant',
    }),
    isValid() {
      return this.addressValid && this.areaValid;
    },
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit('validation', value);
      },
    },
  },
  mounted() {
    this.$emit('validation', this.isValid);
  },
  methods: {
    setValidation(name, value) {
      this[`${name}Valid`] = value;
    },
    validateArea(value) {
      const area = parseInt(value, 10);
      return area < 1000;
    },
  },
};
</script>
